import * as angular from 'angular';
import * as angulartics from 'angulartics';

import * as angularTranslate from 'angular-translate';
import { SidePanelModule } from '../side-panel';
import { goModal } from '../modals';
import { confirmModalModule } from '../modals/confirm';
import { groupDepModel } from '../models/group-dep';

import { PaymentPanel } from './payment-panel.service';
import { enterInformationModule } from './enter-information';
import { groupServiceModule } from '../services/group';
import { messageModalModule } from '../modals/message';

import './style.less';
import { transactionModelModule } from 'go-modules/models/transaction';
import { ngxGroupServiceModule } from '@go-modules/services/group';
import { ngxSelfPayServiceModule } from '@go-modules/services/self-pay';
import { ngxLicenseServiceModule } from '@go-modules/services/license';
import { ngxPurchaseTypeServiceModule } from '@go-modules/services/purchase-type';
import { ngxPHPMathRoundModule } from '@go-modules/services/php-math-round';
import { SelectedModule } from 'go-modules/services/selected';
import { ngxPayWithCodeModule } from '@go-modules/components/payment-panel/pay-with-code';
import { ngxPaymentCompleteModule } from '@go-modules/components/payment-panel/payment-complete';
import { ngxReviewPaymentModule } from '@go-modules/components/payment-panel/review-payment';
import { braintreeModule } from 'go-modules/braintree';
import { ngxDisabledFeaturesServiceModule } from '@go-modules/services/disabled-features';
import { ngxAddressDetailsFormServiceModule } from '@go-modules/services/address-details-form';

export const paymentPanelModule = angular.module('payment-panel', [
	angularTranslate,
	SidePanelModule,
	groupDepModel,
	confirmModalModule,
	enterInformationModule,
	groupServiceModule,
	messageModalModule,
	goModal,
	angulartics as any,
	transactionModelModule,
	ngxGroupServiceModule,
	ngxSelfPayServiceModule,
	ngxLicenseServiceModule,
	ngxPurchaseTypeServiceModule,
	ngxPHPMathRoundModule,
	SelectedModule,
	ngxPayWithCodeModule,
	ngxPaymentCompleteModule,
	ngxReviewPaymentModule,
	braintreeModule,
	ngxDisabledFeaturesServiceModule,
	ngxAddressDetailsFormServiceModule
])
	.service(PaymentPanel.NG1_INJECTION_NAME, PaymentPanel);
